export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    content: string
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            content: '嗯，用户问的是 KingDesign 的发展情况，核心是现在值不值得持续使用和长期前景如何。',
        };
    }
}